import { useContext, useState, createElement, createContext } from "react";
import { useIsomorphicEffect } from "./auth-service-tools644.js";
import { canUseDOM } from "./auth-service-tools646.js";
import { createPortal } from "react-dom";

function getBodyElement() {
  return canUseDOM ? document.body : null;
}

var PortalContext = /* @__PURE__ */createContext(getBodyElement());

function Portal(_ref) {
  var children = _ref.children;
  var context = useContext(PortalContext) || getBodyElement();

  var _React$useState = useState(function () {
    if (canUseDOM) {
      var element = document.createElement("div");
      element.className = Portal.__className;
      return element;
    }

    return null;
  }),
      hostNode = _React$useState[0];

  useIsomorphicEffect(function () {
    if (!hostNode || !context) return void 0;
    context.appendChild(hostNode);
    return function () {
      context.removeChild(hostNode);
    };
  }, [hostNode, context]);

  if (hostNode) {
    return /* @__PURE__ */createPortal( /* @__PURE__ */createElement(PortalContext.Provider, {
      value: hostNode
    }, children), hostNode);
  }

  return null;
}

Portal.__className = "__reakit-portal";
Portal.__selector = "." + Portal.__className;
export { Portal, PortalContext };